import jwtDecode from "jwt-decode";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../config/constants";
import { AuthService } from "../services/authservice";

/**
 * Persiste los tokens de sesión y redirige al landing según el rol del usuario,
 * replicando la lógica de redirección post-login de views/login/login.jsx.
 *
 * Se usa en los flujos de recuperación (enlace y código) para auto-loguear al
 * usuario sin pedirle nada más, tal como hace el login normal.
 *
 * @param {{accessToken: string, refreshToken: string}} tokens
 * @returns {{ok: true} | {ok: false, reason: string}} ok:false cuando el rol no
 *          puede ingresar al portal web (p. ej. repartidores) o el token es inválido.
 */
export function persistSessionAndRedirect(tokens) {
  const accessToken = tokens?.accessToken;
  const refreshToken = tokens?.refreshToken;

  if (!accessToken || !refreshToken) {
    return { ok: false, reason: "MISSING_TOKENS" };
  }

  try {
    localStorage.setItem(ACCESS_TOKEN, accessToken);
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  } catch (e) {
    return { ok: false, reason: "STORAGE_ERROR" };
  }
  // Nueva sesión válida: un aviso de "cuenta bloqueada" de una sesión anterior ya no aplica.
  AuthService.clearSessionEndReason();

  let userData;
  try {
    userData = jwtDecode(accessToken);
  } catch (e) {
    return { ok: false, reason: "INVALID_TOKEN" };
  }

  const type = userData?.role?.type;
  const name = userData?.role?.name;

  // Repartidores / flotas de comercio no operan en el portal web (igual que login.jsx).
  if (name === "delivery" || type === "commerce_fleet") {
    return { ok: false, reason: "ROLE_NOT_ALLOWED" };
  }

  if (type === "company") {
    window.location.replace("/home");
    return { ok: true };
  }
  if (type === "logistic" && name !== "delivery") {
    window.location.replace("/admin/dashboard");
    return { ok: true };
  }
  if (type === "holding") {
    window.location.replace("/holding/packages");
    return { ok: true };
  }

  return { ok: false, reason: "ROLE_NOT_ALLOWED" };
}
